module.exports = __webpack_public_path__ + "img/cross-haze.219b2821.svg";